import { render } from "./BeneficiosPage.vue?vue&type=template&id=627f0a0b&scoped=true"
import script from "./BeneficiosPage.vue?vue&type=script&lang=js"
export * from "./BeneficiosPage.vue?vue&type=script&lang=js"

import "./BeneficiosPage.vue?vue&type=style&index=0&id=627f0a0b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627f0a0b"]])

export default __exports__